


















































import {Component, Vue} from 'vue-property-decorator';
import axios from 'axios';
import EditDialog from './PlanEditShiftCountEditDialog.vue';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';
import {mapState} from 'vuex';
import PlanEditModel from '@/models/PlanEditModel';

@Component({
    components: {
        CSimpleTable,
        EditDialog,
    },
    computed: {
        ...mapState('planEdit', ['planEdit']),
    },
})
export default class PlanShiftCount extends Vue {
    private loading: boolean = false;
    private data: any = null;

    public planEdit!: PlanEditModel | null;

    created() {
        this.getData();
    }

    async getData() {
        const timerId = setTimeout(() => (this.loading = true), 150);
        try {
            const {data} = await this.$http.get(`${this.$api.journals.planShift}/GetAll`, {
                params: {
                    idPlan: this.$route.params.idPlan,
                },
            });
            this.data = data;
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    edit(id: number) {
        if (this.loading) return;
        const cancelRequest = axios.CancelToken.source(),
            request = this.$http.get(`${this.$api.journals.planShift}/GetEdit`, {
                params: {
                    idPlan: this.$route.params.idPlan,
                    number: id,
                },
            });
        (this.$refs.editing as any).openAsync(request, cancelRequest, {
            saveCallback: (data: any) => {
                this.save(data.Item, id);
            },
        });
    }

    async save(model: any, id: any) {
        const {data} = await this.$http.post(`${this.$api.journals.planShift}/Save`, model, {
            params: {
                idPlan: this.$route.params.idPlan,
                number: id,
            },
        });
        this.data = data;
        (this.$refs.editing as any).close();
    }
    async reset(id: number) {
        const timerId = setTimeout(() => (this.loading = true), 150);
        try {
            const {data} = await this.$http.post(`${this.$api.journals.planShift}/Reset`, null, {
                params: {
                    idPlan: this.$route.params.idPlan,
                    number: id,
                },
            });
            this.data = data;
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    update() {
        this.getData();
    }
}
